module.exports = __webpack_public_path__ + "img/bi_categories.a5245a7b.svg";